"use client";

import Image from "next/image";
import { GALLERY } from "@/lib/data";

export function FilmStrip() {
  return (
    <section className="py-8 md:py-12">
      <div className="mb-6 flex items-end justify-between px-5 md:px-8">
        <h2 className="font-display text-4xl md:text-6xl">La ligne de feu.</h2>
        <p className="hidden font-mono text-[10px] tracking-[0.28em] text-brass uppercase md:block">
          Glisser →
        </p>
      </div>
      <div className="film-strip flex gap-3 overflow-x-auto px-5 pb-4 md:px-8">
        {GALLERY.map((shot) => (
          <figure
            key={shot.src + shot.caption}
            className="hud-frame relative h-[58vh] min-h-[320px] w-[78vw] shrink-0 overflow-hidden sm:w-[46vw] lg:w-[32vw]"
          >
            <Image
              src={shot.src}
              alt={shot.caption}
              fill
              className="object-cover"
              style={{ objectPosition: shot.pos }}
              sizes="40vw"
            />
            <figcaption className="absolute inset-x-0 bottom-0 bg-linear-to-t from-ink to-transparent p-5 font-mono text-[10px] tracking-[0.22em] text-brass uppercase">
              {shot.caption}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
